import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Gallery2 from './pages/Gallery2';
import ChatBot from './components/ChatBot';
import Partners from './pages/Partners';
import Gallery3 from './pages/Gallery3';
import Timeline from './pages/Timeline';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery2" element={<Gallery2 />} />
            <Route path="/gallery3" element={<Gallery3 />} />
            {/* <Route path="/timeline" element={<Timeline />} /> */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/partners" element={<Partners />} />
          </Routes>
        </main>
        <ChatBot />
      </div>
    </Router>
  );
};

export default App;